import React, { useState, useEffect, useCallback } from 'react';
import { db } from '../../firebase';
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc } from 'firebase/firestore';

const ManageTestimonials = () => {
    const [testimonials, setTestimonials] = useState([]);
    const [name, setName] = useState('');
    const [quote, setQuote] = useState('');
    const [editingId, setEditingId] = useState(null);

    const fetchTestimonials = useCallback(async () => {
        const testimonialsCollectionRef = collection(db, "testimonials");
        const data = await getDocs(testimonialsCollectionRef);
        setTestimonials(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    }, []);

    useEffect(() => {
        fetchTestimonials();
    }, [fetchTestimonials]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const testimonialsCollectionRef = collection(db, "testimonials");
        if (editingId) {
            const testimonialDoc = doc(db, "testimonials", editingId);
            await updateDoc(testimonialDoc, { name, quote });
        } else {
            await addDoc(testimonialsCollectionRef, { name, quote });
        }
        resetForm();
        fetchTestimonials();
    };

    const handleEdit = (testimonial) => {
        setEditingId(testimonial.id);
        setName(testimonial.name);
        setQuote(testimonial.quote);
    };

    const handleDelete = async (id) => {
        if (window.confirm("Tem certeza que deseja excluir este depoimento?")) {
            const testimonialDoc = doc(db, "testimonials", id);
            await deleteDoc(testimonialDoc);
            fetchTestimonials();
        }
    };

    const resetForm = () => {
        setEditingId(null);
        setName('');
        setQuote('');
    };

    return (
        <div className="bg-neutral-800 p-6 rounded-lg">
            <h2 className="text-xl font-bold text-white mb-4">Gerenciar Depoimentos</h2>
            <form onSubmit={handleSubmit} className="mb-6 space-y-4">
                <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Nome do Cliente" className="w-full p-2 bg-neutral-700 rounded" required />
                <textarea value={quote} onChange={(e) => setQuote(e.target.value)} placeholder="Depoimento" className="w-full p-2 bg-neutral-700 rounded" required />
                <div className="flex gap-2">
                    <button type="submit" className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-500">{editingId ? 'Atualizar Depoimento' : 'Adicionar Depoimento'}</button>
                    {editingId && <button type="button" onClick={resetForm} className="bg-gray-500 text-white px-4 py-2 rounded">Cancelar</button>}
                </div>
            </form>
            <div>
                {testimonials.map(testimonial => (
                    <div key={testimonial.id} className="bg-neutral-700 p-3 rounded mb-2">
                        <p className="italic">"{testimonial.quote}"</p>
                        <div className="flex justify-between items-center mt-2">
                            <span className="font-bold">- {testimonial.name}</span>
                            <div className="flex gap-2">
                                <button onClick={() => handleEdit(testimonial)} className="bg-blue-600 text-white px-3 py-1 rounded">Editar</button>
                                <button onClick={() => handleDelete(testimonial.id)} className="bg-red-600 text-white px-3 py-1 rounded">Excluir</button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ManageTestimonials;
